module.exports = __webpack_public_path__ + "img/2020_12_24_snowman.bbef6238.jpg";